import { FixedDiscountRuleForm } from "@refund/register-fixed-discount-rules/register/components";
import { useRefundRule } from "@refund/query-fixed-discount-rules/hooks";
import { useParams } from "react-router-dom";
import { ApiLoadingSpinner, ApiRequestError, BreadCrumb, Title } from "@funcional/react-ui";

export default function ViewFixedDiscountRulePage() {
  const { ruleId }: { ruleId: string } = useParams();

  const { status, data, error, isFetching, refetch } = useRefundRule(
    isNaN(parseInt(ruleId)) ? '' as any as number : parseInt(ruleId)
  );

  return (<>
    {status === "loading" ? (
      <ApiLoadingSpinner />
    ) : (status === "error" || !data) ? (
      data ? (
        <div>
          <p>Ocorreu um erro na obtenção dos dados relacionados a essa regra.</p>
          <p>Tente novamente mais tarde, caso o problema persista entre em contato com o administrador do sistema.</p>
        </div>
      ) : (
        <ApiRequestError error={error} />
      )
    ) : Object.values(data).length > 0 ? (
      <div>
        <Title>Visualizar Regra de Desconto Fixo</Title>
        <BreadCrumb
          items={[
            {
              path: "/refund/fixed-discount-rule",
              label: "Regras de Desconto Fixo"
            },
            {
              label: "Visualizar regra de desconto fixo"
            },
            {
              label: ruleId,
            },
          ]}
        />
        <FixedDiscountRuleForm
          onSubmit={() => undefined}
          viewMode
          defaults={data}
        />
      </div>
    ) : (
      <div>Nenhuma regra de desconto fixo foi encontrada para esse ID.</div>
    )}
  </>);
}
